import { Autocomplete, TextField } from '@mui/material';
import { InputLabel, InputGroup, InputContainer } from '../modalStyles';
import Profile from 'components/Profile';
const AddGroupMembersDropdown = ({ handleAddMember, companyMembers }) => {

  const filterCompanyMembers = (options, { inputValue }) => {
    return options.filter(
      (option) =>
        option?.name?.toLowerCase().includes(inputValue.toLowerCase()) ||
        option?.email?.toLowerCase().includes(inputValue.toLowerCase())
    );
  };

  return (
    <InputContainer>
      <InputGroup>
        <InputLabel>Add User</InputLabel>
        <Autocomplete
          size="small"
          fullWidth
          onChange={handleAddMember}
          options={companyMembers || []}
          getOptionLabel={(option) => option?.name || option?.email || ''}
          filterOptions={filterCompanyMembers}
          renderInput={(params) => (
            <TextField {...params} placeholder="Add group members by email or name" />
          )}
          renderOption={(props, option) => (
            <li {...props}>
              <Profile text={option?.name} subText={option?.email} />
            </li>
          )}
        />
      </InputGroup>
    </InputContainer>
  );
};
export default AddGroupMembersDropdown;
